import { render } from "./MWAdminNavbar.vue?vue&type=template&id=39df7e80"
import script from "./MWAdminNavbar.vue?vue&type=script&lang=js"
export * from "./MWAdminNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__